import Service from "./Service";
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export class StudentExamService extends Service{
    constructor() {
        super();
        this.baseURL = 'studentExam';
    }

    create(data) {
        return fetch(SERVER_URL + this.baseURL, {
            crossDomain: true,
            method: 'post',
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")},
            body: JSON.stringify(GeneralUtils.addCreateInfo(data))
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    update(data) {
        return fetch(SERVER_URL + this.baseURL, {
            crossDomain: true,
            method: 'put',
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")},
            body: JSON.stringify(GeneralUtils.addUpdateInfo(data))
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    findByCourseId(courseId) {
        return fetch(SERVER_URL + this.baseURL + '/findByCourseId/' + courseId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}